const screenshots = [
  {
    title: "Scout Conecta",
    description: "Sistema integral para el movimiento scout mexicano con gestión de progresión, mensajería y recursos educativos.",
    image: "/imagenes/scout conecta.png"
  },
  {
    title: "Ascensos App Vortex",
    description: "Plataforma educativa completa con IA para estudiar leyendo, escuchando e interactuando en la Marina de México.",
    image: "/imagenes/ascensos app vortex.png"
  },
  {
    title: "Vortex Texto - Audio",
    description: "Convierte textos en audios de alta calidad con síntesis de voz avanzada para estudiantes y profesionales.",
    image: "/imagenes/vortex texto a audios.png"
  },
  {
    title: "Vortex Audio Texto IA",
    description: "Transcripción automática de audio a texto usando IA avanzada de Whisper para grabaciones y archivos.",
    image: "/imagenes/vortex audio a textos.png"
  },
  {
    title: "Flashcard Vortex",
    description: "Sistema de tarjetas de estudio inteligente con mapeo conceptual y aprendizaje adaptativo impulsado por IA.",
    image: "/imagenes/flashcards.png"
  },
  {
    title: "Ascensos App Lite",
    description: "Versión especializada para preparación de exámenes de ascenso en la Armada de México.",
    image: "/imagenes/ascensos app lite.png"
  },
  {
    title: "Cuentos que enseñan",
    description: "Aplicación que transforma temas escolares en cuentos divertidos generados por IA para niños de primaria.",
    image: "/imagenes/cuentos que ensenan.png"
  },
  {
    title: "Próximas Innovaciones",
    description: "Estamos desarrollando nuevas aplicaciones revolucionarias. ¡Mantente conectado para futuras sorpresas!",
    image: "/icons/ai.png"
  }
]

export default function Screenshots() {
  return (
    <section id="screenshots" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Nuestras Aplicaciones</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto' }}>
            Explora nuestras aplicaciones móviles innovadoras y descubre cómo pueden transformar tu experiencia de aprendizaje
          </p>
        </div>

        <div className="grid grid-3">
          {screenshots.map((screenshot, index) => (
            <div
              key={index}
              style={{
                background: 'var(--bg-tertiary)',
                borderRadius: 'var(--radius-lg)',
                padding: 'var(--spacing-lg)',
                border: '1px solid var(--border)',
                transition: 'all var(--transition-normal)',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-4px)'
                e.target.style.boxShadow = 'var(--shadow-lg)'
                e.target.style.borderColor = 'var(--accent)'
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)'
                e.target.style.boxShadow = 'none'
                e.target.style.borderColor = 'var(--border)'
              }}
            >
              <img
                src={screenshot.image}
                alt={screenshot.title}
                style={{
                  width: '100%',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: 'var(--radius-md)',
                  marginBottom: 'var(--spacing-md)',
                  border: '1px solid var(--border)'
                }}
              />
              <h4 style={{
                marginBottom: 'var(--spacing-sm)',
                color: 'var(--text-primary)'
              }}>
                {screenshot.title}
              </h4>
              <p style={{
                color: 'var(--text-secondary)',
                fontSize: '0.9rem',
                margin: 0
              }}>
                {screenshot.description}
              </p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: 'var(--spacing-3xl)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>
            Tecnología al servicio de la educación
          </h3>
          <p style={{ marginBottom: 'var(--spacing-xl)' }}>
            Interfaces intuitivas y potentes funcionalidades que hacen del aprendizaje una experiencia excepcional
          </p>
          <a href="#availability" className="btn btn-primary">
            Descargar aplicaciones
          </a>
        </div>
      </div>
    </section>
  )
} 